/* eslint-disable no-nested-ternary */
// @flow
import * as React from 'react';
// import classNames from 'classnames';
import Icon from '../Icon';
import styles from './styles.module.scss';

type Props = {
  checked: ?boolean,
  onCheck: () => void,
  label: string,
  value: string,
  disabled?: ?boolean,
  previousIsDel?: boolean,
  nextIsDel?: boolean,
  defaultCheck?: boolean,
  disabledByFree?: boolean,
}

const Check = ({
  checked,
  onCheck,
  label,
  value,
  disabled,
  previousIsDel,
  nextIsDel,
  defaultCheck,
  disabledByFree,
}: Props) => (
  <button
    type="button"
    className={`
      ${styles.checkboxWrapper}
      ${disabled ? styles.disabled : ''} ${checked ? styles.checkedButton : ''}
      ${previousIsDel ? styles.firstItem : ''}
      ${nextIsDel ? styles.lastItem : ''}
      ${disabledByFree ? styles.disabledByFree : ''}
    `}
    onClick={() => (
      // eslint-disable-next-line max-len
      (disabled || disabledByFree) ? null : defaultCheck
        ? onCheck() : onCheck({ isChecked: !checked, value }))}
  >
    <div className={`${styles.checkbox} ${checked ? styles.checked : ''}`}>
      {checked ? <Icon icon="check" /> : null}
    </div>
    <span className={`${styles.label} ${disabled ? styles.disabledLabel : ''}`}>
      {label}
    </span>
  </button>
);

export default Check;
